import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Faq, { faqJsonLd } from './Faq';
import Seo from './Seo';
import { FAQ_GROUPES } from '../utils/faq';
import { LIFE_EVENTS, CARTES_PATH } from '../utils/lifeEvents';
import { MINISITE_HUB_PATH } from '../utils/minisiteOccasions';

// Page « Questions fréquentes » : toutes les questions de faq.json, par thème. Garde l'adresse
// historique de la FAQ des cartes à gratter (référencée, liée depuis l'accueil et le menu).
const FaqPage = () => (
  <Box sx={{ padding: { xs: 1, sm: 3 } }}>
    <Seo
      titre="Questions fréquentes : faire-part animés et cartes à gratter"
      description="Paiement unique, contenu de chaque formule, réponses des invités, envoi par WhatsApp, durée en ligne : tout sur les faire-part animés et les cartes à gratter."
      path="/carte-a-gratter-digitale-questions-frequentes"
    />
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd(FAQ_GROUPES.flatMap((g) => g.questions)))}</script>
    </Helmet>
    <Typography variant="h1" sx={{ textAlign: 'center', marginBottom: 2 }}>Questions fréquentes</Typography>
    <Typography sx={{ maxWidth: 760, margin: '0 auto', textAlign: 'center' }}>
      Tout ce qu'il faut savoir sur nos <Link to={MINISITE_HUB_PATH}>faire-part et invitations animés</Link> et nos{' '}
      <Link to={CARTES_PATH}>cartes à gratter numériques</Link>. Une question sans réponse ? <Link to="/contact">Écrivez-nous</Link>.
    </Typography>
    {FAQ_GROUPES.map((groupe) => (
      <Faq key={groupe.titre} items={groupe.questions} titre={groupe.titre} balise={false} />
    ))}
    <Typography sx={{ maxWidth: 820, margin: '40px auto 0' }}>
      Par événement : {LIFE_EVENTS.map((event, index) => (
        <React.Fragment key={event.key}>{index > 0 && ' · '}<Link to={event.path}>{event.label}</Link></React.Fragment>
      ))}
    </Typography>
  </Box>
);

export default FaqPage;
